import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=8e7ae5ca&scoped=true"
import script from "./OrderPanel.vue?vue&type=script&lang=js"
export * from "./OrderPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderPanel.vue?vue&type=style&index=0&id=8e7ae5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7ae5ca",
  null
  
)

export default component.exports